"use client"

import { ColumnDef } from "@tanstack/react-table"
import { UserActionsDropdown } from "./user-actions-dropdown"

export type UserColumns = {
  id: string
  handle?: string | null | undefined
  fullName: string
  email?: string | null | undefined
  createdAt: string
}

export const columns: ColumnDef<UserColumns | null | undefined>[] = [
  {
    accessorKey: "fullName",
    header: "Name",
    cell: ({ row }) => {
      return (
        <>
          <div className="text-sm">{row.getValue("fullName")}</div>
          <div className="text-gray-500">{row.original?.email}</div>
        </>
      )
    },
  },
  {
    accessorKey: "handle",
    header: "Handle",
    cell: ({ row }) => {
      const handle = row.getValue("handle") as string | null | undefined
      return (
        <div className="font-mono text-sm">
          {handle ? `@${handle}` : <span className="text-gray-400">No handle</span>}
        </div>
      )
    },
  },
  {
    accessorKey: "createdAt",
    header: "Created at",
    cell: ({ row }) => {
      const date = new Date(row.getValue("createdAt"))
      return (
        <div className="text-sm">
          {date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
        </div>
      )
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      return (
        <div className="flex items-center gap-2">
          {row.original?.id && <UserActionsDropdown userId={row.original.id} />}
        </div>
      )
    },
  },
]
